// extracted by mini-css-extract-plugin
export default {"altLoginLink":"ZEnoiv","link":"QIzZ7U"};